import axiosInstance from "../interceptor/instance";

export const initiateFile = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL_FILE}`,
    data
  );
  return response.data;
};

export const listProcessing = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL_FILE}/processing`
  );
  return response.data;
};

export const updateFileStatus = async (id, status) => {
  const response = await axiosInstance.put(
    `${process.env.REACT_APP_BASE_URL_FILE}/${id}`,
    { status }
  );
  return response.data;
};
